import smartSolveApi from './instances/smartsolve';

export const getGlobalSearchEntities = async () => {
  try {
    const response = await smartSolveApi.post('/getglobalsearchentities');

    return response.data;
  } catch (e) {
    throw new Error(`getGlobalSearchEntities() failed: ${e}`);
  }
};

export const getEnhancedGlobalSearchResults = async (data) => {
  try {
    const response = await smartSolveApi.post('/enhancedglobalsearch', data);

    return response.data;
  } catch (e) {
    throw new Error(`getEnhancedGlobalSearchResults() failed: ${e}`);
  }
};

export const getEnhancedGlobalSearchExport = async (exportParameters) => {
  try {
    const response = await smartSolveApi.post('/exportEnhancedGlobalSearchData', exportParameters, {
      responseType: 'blob',
    });

    return response.data;
  } catch (e) {
    throw new Error(`getSavedSearchExport failed: ${e}`);
  }
};

export const getEnhancedGlobalRecordNumberSearch = async (parameters) => {
  try {
    const response = await smartSolveApi.post('/EnhancedGlobalRecordNumberSearch', parameters);

    return response.data;
  } catch (e) {
    throw new Error(`getEnhancedGlobalRecordNumberSearch failed: ${e}`);
  }
};
